import { __assign } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createTranslateFn, deprecatedMsg } from './../..';
export var renderAndMountComponent = function (component) {
    var elem = document.createElement('div');
    elem.id = 'test-root-container';
    document.body.appendChild(elem);
    ReactDOM.render(component, elem);
    return elem;
};
export var renderAndMountComp = function (Comp, props) {
    var elem = document.createElement('div');
    elem.id = 'test-root-container';
    document.body.appendChild(elem);
    ReactDOM.render(React.createElement(Comp, props), elem);
    return elem;
};
/* Deprecated!!! */
export var renderAndMountAnsViewComponent = function (Comp, props) {
    deprecatedMsg("renderAndMountAndViewComponent is deprecated. Please use 'renderAndMountComp' with 'testViewCompPropsCreator'");
    var t = createTranslateFn(function (key) { return key; });
    var p = __assign({ t: t }, props);
    return renderAndMountComponent(React.createElement(Comp, p));
};
//# sourceMappingURL=render-and-mount.js.map